import { render } from "./TransactionMeta.vue?vue&type=template&id=704341a0&scoped=true"
import script from "./TransactionMeta.vue?vue&type=script&lang=js"
export * from "./TransactionMeta.vue?vue&type=script&lang=js"

import "./TransactionMeta.vue?vue&type=style&index=0&id=704341a0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704341a0"]])

export default __exports__